function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
export { _typeof as default };


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/helpers/esm/typeof.js
// module id = ./node_modules/@babel/runtime/helpers/esm/typeof.js
// module chunks = 1